import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const EmptyState = ({ hasFilters, onClearFilters }) => {
  const navigate = useNavigate();

  if (hasFilters) {
    return (
      <div className="bg-surface border border-border rounded-lg p-12 text-center">
        <div className="w-16 h-16 bg-muted rounded-full flex items-center justify-center mx-auto mb-4">
          <Icon name="Search" size={32} className="text-text-secondary" />
        </div>
        <h3 className="text-lg font-semibold text-text-primary mb-2">
          No se encontraron resultados
        </h3>
        <p className="text-text-secondary mb-6 max-w-md mx-auto">
          No hay lotes de carga que coincidan con los filtros aplicados. 
          Intenta ajustar los criterios de búsqueda.
        </p>
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Button
            variant="outline"
            onClick={onClearFilters}
            iconName="X"
            iconPosition="left"
          >
            Limpiar Filtros
          </Button>
          <Button
            variant="primary"
            onClick={() => navigate('/bulk-upload')}
            iconName="Upload"
            iconPosition="left"
          >
            Nueva Carga
          </Button>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-surface border border-border rounded-lg p-12 text-center">
      <div className="w-20 h-20 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-6">
        <Icon name="History" size={40} className="text-primary" />
      </div>
      <h3 className="text-xl font-semibold text-text-primary mb-3">
        No hay historial de cargas
      </h3>
      <p className="text-text-secondary mb-8 max-w-lg mx-auto">
        Aún no has realizado ninguna carga de productos. Comienza subiendo tu primer 
        archivo Excel o CSV para ver el historial de tus publicaciones en MercadoLibre.
      </p>
      
      <div className="flex flex-col sm:flex-row gap-4 justify-center mb-8">
        <Button
          variant="primary"
          onClick={() => navigate('/bulk-upload')}
          iconName="Upload"
          iconPosition="left"
          size="lg"
        >
          Subir Productos
        </Button>
        <Button
          variant="outline"
          onClick={() => navigate('/dashboard')}
          iconName="LayoutDashboard"
          iconPosition="left"
          size="lg"
        >
          Ir al Dashboard
        </Button>
      </div>

      <div className="border-t border-border pt-8">
        <h4 className="font-semibold text-text-primary mb-4">¿Necesitas ayuda para empezar?</h4>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 text-sm">
          <div className="flex flex-col items-center p-4 bg-muted/30 rounded-lg">
            <Icon name="FileText" size={24} className="text-primary mb-2" />
            <span className="font-medium text-text-primary">Descarga la plantilla</span>
            <span className="text-text-secondary text-center">
              Usa nuestro formato CSV para estructurar tus productos
            </span>
          </div>
          <div className="flex flex-col items-center p-4 bg-muted/30 rounded-lg">
            <Icon name="Settings" size={24} className="text-primary mb-2" />
            <span className="font-medium text-text-primary">Configura la API</span>
            <span className="text-text-secondary text-center">
              Conecta tu cuenta de MercadoLibre para publicar
            </span>
          </div>
          <div className="flex flex-col items-center p-4 bg-muted/30 rounded-lg">
            <Icon name="Upload" size={24} className="text-primary mb-2" />
            <span className="font-medium text-text-primary">Sube tus productos</span>
            <span className="text-text-secondary text-center">
              Arrastra tu archivo y comienza la publicación masiva
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmptyState;